import { Crown } from "lucide-react";
import { format } from "date-fns";
import { useUnlimitedStatus } from "@/hooks/useUnlimitedStatus";

type UnlimitedStatusCardProps = {
  compact?: boolean;
};

const UnlimitedStatusCard = ({ compact = false }: UnlimitedStatusCardProps) => {
  const { data: unlimitedStatus, isLoading } = useUnlimitedStatus();

  if (isLoading || !unlimitedStatus?.isUnlimited) {
    return null;
  }

  const formattedExpiry = unlimitedStatus.expiresAt
    ? format(unlimitedStatus.expiresAt, "MMMM dd, yyyy")
    : "Unknown";

  if (compact) {
    return (
      <div className="bg-gradient-to-br from-amber-500/20 via-yellow-500/10 to-orange-500/20 border-2 border-amber-500/40 rounded-lg p-4 shadow-lg">
        <div className="flex items-center gap-2">
          <Crown className="text-amber-500 h-5 w-5" />
          <span className="font-bold text-amber-700 dark:text-amber-400">
            Unlimited Member
          </span>
          <span className="text-sm text-muted-foreground ml-auto">
            {unlimitedStatus.daysRemaining} day{unlimitedStatus.daysRemaining !== 1 ? "s" : ""} left
          </span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-gradient-to-br from-amber-500/20 via-yellow-500/10 to-orange-500/20 border-2 border-amber-500/40 rounded-lg p-5 shadow-lg">
      <div className="flex items-center mb-4">
        <Crown className="text-amber-500 mr-2 h-6 w-6" />
        <h2 className="text-lg font-bold text-amber-700 dark:text-amber-400">
          Unlimited Member
        </h2>
      </div>

      <div className="space-y-3">
        <p className="text-sm font-medium text-foreground">
          Book any experience for free!
        </p>
        <div className="bg-card/50 rounded-md p-3 space-y-1">
          <p className="text-sm text-muted-foreground">
            Expires: <span className="font-semibold text-foreground">{formattedExpiry}</span>
          </p>
          <p className="text-sm text-amber-600 dark:text-amber-400 font-medium">
            {unlimitedStatus.daysRemaining} day{unlimitedStatus.daysRemaining !== 1 ? "s" : ""} remaining
          </p>
        </div>
      </div>
    </div>
  );
};

export default UnlimitedStatusCard;
